import { appService } from "../../services/appService";
import { handleError } from "../../utils/errors";

export default async (to, from, next) => {
    try {
        await appService.permissions("r", to.meta.clsnam);
        next();
    } catch (error) {
        handleError(error);
        next({ name: "PageNotFound" });
    }
};
